import React, { useState } from "react"
import { Grid, FormControl, Select, MenuItem, CircularProgress } from "@material-ui/core"

import ApiService from "@/services/Api"
import { Notification } from "@/components"
import { ContactsFiltersConditions } from "@/protocols/ClientCatalogFilterProtocol"
import useDidMount from "@/hooks/useDidMount"

type ContactImportUpdateProps = {
	condition: ContactsFiltersConditions<"client_catalog_contacts_updated_by_contacts_import">
	onChange: (condition: ContactsFiltersConditions<"client_catalog_contacts_updated_by_contacts_import">) => void
}

const MAX_UPDATE_HISTORY_COUNT_TO_FILTER = 30

type ImportHistory = { id: number }

const ContactUpdatedByImportFeatureFilterCondition: React.FC<ContactImportUpdateProps> = ({ condition, onChange }) => {
	const [importHistoryList, setImportHistoryList] = useState<ImportHistory[]>([])
	const [loading, setLoading] = useState(false)

	const fetchUpdateHistory = async () => {
		setLoading(true)
		try {
			const response = await ApiService.get("/clients/contacts/imports-history-to-filter")
			if (response.data) {
				setImportHistoryList(response.data.slice(0, MAX_UPDATE_HISTORY_COUNT_TO_FILTER))
			}
		} catch (error) {
			Notification.error({ message: "Erro ao carregar histórico de atualizações" })
		}
		setLoading(false)
	}

	const handleChange = (importId: number) => {
		onChange({
			type: "client_catalog_contacts_updated_by_contacts_import",
			operator: "equal",
			filterData: {
				client_catalog_contacts_updated_by_contacts_import_id: importId
			}
		})
	}

	useDidMount(() => {
		fetchUpdateHistory()
	})

	return (
		<Grid container direction="row" spacing={2}>
			<Grid item xs={12}>
				<FormControl fullWidth variant="outlined" size="small">
					<Select
						value={condition.filterData.client_catalog_contacts_updated_by_contacts_import_id || ""}
						onChange={({ target }) => handleChange(Number(target.value))}
						endAdornment={loading ? <CircularProgress size={20} thickness={4} /> : null}
					>
						{importHistoryList.map(item => (
							<MenuItem key={item.id} value={item.id}>
								Atualização #{item.id}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Grid>
		</Grid>
	)
}

export default ContactUpdatedByImportFeatureFilterCondition
